import motivationCarousel from './motivationCarousel';

(() => {
  motivationCarousel();
})();
